module.exports = __webpack_public_path__ + "static/media/view.e6694b02.svg";